module.exports = __webpack_public_path__ + "img/Js.3a273083.svg";